

import React, { useState } from "react";

const Chatbot = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { sender: "bot", text: "Hi! I'm FashionBot 👗. Ask me anything!" }
  ]);
  const [input, setInput] = useState("");

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMsg = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMsg]);
    setInput("");

    try {
      const res = await fetch("http://localhost:5454/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: input }),
      });

      const data = await res.json();
      const botMsg = { sender: "bot", text: data.reply || "Sorry, something went wrong." };
      setMessages((prev) => [...prev, botMsg]);
    } catch (err) {
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "Server error. Please try again later." },
      ]);
    }
  };

  return (
    <>
      <div
        className="fixed bottom-6 right-6 bg-[#854d0e] text-white rounded-full p-4 cursor-pointer shadow-lg"
        onClick={() => setOpen(!open)}
      >
        💬
      </div>

      {open && (
        <div className="fixed bottom-24 right-6 w-80 bg-[#fffaf0] border border-[#854d0e] rounded-xl shadow-lg flex flex-col z-50">
          <div className="bg-[#854d0e] text-white p-3 flex justify-between items-center rounded-t-xl">
            <h3 className="font-semibold">FashionBot</h3>
            <button onClick={() => setOpen(false)}>×</button>
          </div>
          <div className="h-64 overflow-y-auto p-3 text-sm space-y-2">
            {messages.map((msg, idx) => (
              <div key={idx} className={`text-${msg.sender === "user" ? "right" : "left"}`}>
                <p><strong>{msg.sender === "user" ? "You" : "FashionBot"}:</strong> {msg.text}</p>
              </div>
            ))}
          </div>
          <div className="p-2 flex border-t border-[#854d0e]">
            <input
              className="flex-1 px-2 py-1 border border-gray-300 rounded"
              placeholder="Ask a question..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            />
            <button className="ml-2 px-3 py-1 rounded text-white bg-[#854d0e]" onClick={sendMessage}>
              Send
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Chatbot;

